import { Component,Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { BaseComponent } from '../BaseComponent';
import { Form, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'embed-code-dialog',
  templateUrl: './embed-code-dialog.html'
})
export class EmbedCodeDialog extends BaseComponent {
  url: string;
  width: number;
  widthUnit: number;
  height: number;
  heightUnit: number;

  embedCodeControl = new FormControl('');
  widthControl = new FormControl('');
  widthUnitControl = new FormControl('');
  heightControl = new FormControl('');
  heightUnitControl = new FormControl('');

  constructor(public router: Router, public snackBar: MatSnackBar, public dialogRef: MatDialogRef<EmbedCodeDialog>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) {
    super(router, snackBar, dialog);

    this.init();

    // Set defaults
    this.url = data.url;
    this.widthControl.setValue(typeof data.width !== 'undefined' ? data.width : 100);
    this.widthUnitControl.setValue(typeof data.widthUnit !== 'undefined' ? data.widthUnit : '%');
    this.heightControl.setValue(typeof data.height !== 'undefined' ? data.height : 100);
    this.heightUnitControl.setValue(typeof data.heightUnit !== 'undefined' ? data.heightUnit : '%');
  }

  init() {
    let widthEmbedControlWater = new EmbedControlWatcher(this.widthControl);
    widthEmbedControlWater.valueChanged().subscribe(newVal => {
      this.width = newVal;
      this.generateEmbedCode();
    });

    let widthUnitEmbedControlWater = new EmbedControlWatcher(this.widthUnitControl);
    widthUnitEmbedControlWater.valueChanged().subscribe(newVal => {
      this.widthUnit = newVal;
      this.generateEmbedCode();
    });

    let heightEmbedControlWater = new EmbedControlWatcher(this.heightControl);
    heightEmbedControlWater.valueChanged().subscribe(newVal => {
      this.height = newVal;
      this.generateEmbedCode();
    });

    let heightUnitEmbedControlWater = new EmbedControlWatcher(this.heightUnitControl);
    heightUnitEmbedControlWater.valueChanged().subscribe(newVal => {
      this.heightUnit = newVal;
      this.generateEmbedCode();
    });
  }

  copyToClipboard() {
    let embedCode = this.embedCodeControl.value;

    const listener = function(ev) {
      ev.preventDefault();
      ev.clipboardData.setData('text/plain', embedCode);
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);

    // assume success
    this.openSnackBarSuccess('GENERIC.COPIED');
  }

  done() {
    this.dialogRef.close();
  }

  generateEmbedCode() {
    this.embedCodeControl.setValue(`<iframe src="${ this.url }" height="${ this.height }${ this.heightUnit }" width="${ this.width }${ this.widthUnit }" style="border: none;"></iframe>`);
  }
}

class EmbedControlWatcher {
  formControl: FormControl;
  target: any;

  constructor(formControl: FormControl) {
    this.formControl = formControl;
  }

  valueChanged(): Observable<any> {
    const observable = new Observable(subscriber => {
      this.formControl.valueChanges.subscribe(x => {
        if (this.formControl.valid) {
          subscriber.next(x);
        }
      });
    });

    return observable;
  }
}
